import type { Folder } from '@efdigital/ll-addon-data/types/content/folder';
import { EditRecord } from '@efdigital/ll-admin-v2/components/edit-record.gts';
import { type EditRecordSignature } from '@efdigital/ll-admin-v2/components/edit-record-base.gts';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

export default class FolderCreate extends Component<
  EditRecordSignature<Folder>
> {
  updateFolderName = (event: Event) => {
    this.args.item.name = (event.target as HTMLInputElement).value;
  };

  <template>
    <EditRecord
      @item={{@item}}
      @context={{@context}}
      @editLabel="Create Folder"
      @maxDepth={{1}}
      @initialState="edit"
    >
      <:form as |uniqueId isDisabled|>
        <fieldset disabled={{isDisabled}} class="mb-0">
          <legend class="gud-eyebrow">Folder Name</legend>
          <div class="mb-3">
            <label
              for="{{uniqueId}}-name"
              class="form-label required visually-hidden"
            >Folder Name</label>
            <div class="form-text mb-1">The folder name cannot be changed after
              creation.</div>
            <input
              type="text"
              id="{{uniqueId}}-name"
              class="form-control"
              value={{@item.name}}
              {{on "input" this.updateFolderName}}
              required
              placeholder="Enter folder name"
            />
          </div>
        </fieldset>
      </:form>
    </EditRecord>
  </template>
}
